import { useMemo } from 'react';

import { deleteOptionsByValues } from '../../../../../../../shared/utils/arrayUtils';
import {
  CHALLENGE_CUSTOMER_TYPE,
  challengeCustomerTypeOptions,
} from '../../../../../../constants/challengeCustomerType';
import { SolutionTypeFlags } from '../../../../../../../shared/constants/user-info/solutionType';

/**
 * LIFE_BASE_USERS option available only when NUTRITION solution is available
 */
export const useCustomerTypeOptions = (availableSolutionsFlags: SolutionTypeFlags) => {
  const availableCustomerTypeOptions = useMemo(() => {
    if (!availableSolutionsFlags.NUTRITION) {
      return deleteOptionsByValues(challengeCustomerTypeOptions, [
        CHALLENGE_CUSTOMER_TYPE.LIFE_BASE_USERS,
      ]);
    }

    return challengeCustomerTypeOptions;
  }, [availableSolutionsFlags.NUTRITION]);

  return availableCustomerTypeOptions;
};
